import React from 'react';
import { CheckCircle } from 'lucide-react';

const phases = [
    { id: 'hook', name: 'Identity', emoji: '🎯', steps: [1, 2] },
    { id: 'story', name: 'Background', emoji: '📖', steps: [3, 4] },
    { id: 'dream', name: 'Goals', emoji: '🌟', steps: [5, 6] },
    { id: 'reality', name: 'Commitment', emoji: '⚡', steps: [7, 8] }
];

const JourneyProgress = ({ currentStep, totalSteps = 8, showGlimpse = false }) => {
    const getCurrentPhase = () => {
        for (let i = 0; i < phases.length; i++) {
            if (phases[i].steps.includes(currentStep)) {
                return i;
            }
        }
        return 0;
    };

    const currentPhaseIndex = getCurrentPhase();

    return (
        <div className="mb-8">
            {/* Phase indicators */}
            <div className="flex items-center justify-between mb-6">
                {phases.map((phase, index) => (
                    <React.Fragment key={phase.id}>
                        <div className="flex flex-col items-center">
                            <div
                                className={`w-12 h-12 rounded-2xl flex items-center justify-center text-xl transition-all duration-500 ${index < currentPhaseIndex
                                    ? 'bg-emerald-500/20 border-2 border-emerald-500'
                                    : index === currentPhaseIndex
                                        ? 'bg-gradient-to-br from-emerald-500 to-teal-500 shadow-lg shadow-emerald-500/30 scale-110'
                                        : 'bg-[#0F131F] border-2 border-white/10'
                                    }`}
                            >
                                {index < currentPhaseIndex ? (
                                    <CheckCircle className="w-6 h-6 text-emerald-400" />
                                ) : (
                                    <span>{phase.emoji}</span>
                                )}
                            </div>
                            <span
                                className={`mt-2 text-xs font-mono uppercase tracking-wider ${index <= currentPhaseIndex ? 'text-emerald-400' : 'text-slate-500'
                                    }`}
                            >
                                {phase.name}
                            </span>
                        </div>
                        {index < phases.length - 1 && (
                            <div
                                className={`flex-1 h-1 mx-2 rounded-full transition-all duration-500 ${index < currentPhaseIndex
                                    ? 'bg-emerald-500'
                                    : 'bg-white/10'
                                    }`}
                            />
                        )}
                    </React.Fragment>
                ))}
            </div>

            {/* Step indicators within current phase */}
            <div className="flex items-center justify-center space-x-2">
                {Array.from({ length: totalSteps }, (_, i) => i + 1).map((step) => (
                    <div
                        key={step}
                        className={`transition-all duration-300 ${step === currentStep
                            ? 'w-8 h-2 rounded-full bg-gradient-to-r from-emerald-500 to-teal-500'
                            : step < currentStep
                                ? 'w-2 h-2 rounded-full bg-emerald-500'
                                : 'w-2 h-2 rounded-full bg-white/20'
                            }`}
                    />
                ))}
            </div>

            {/* Career glimpse indicator */}
            {showGlimpse && currentStep >= 4 && (
                <div className="mt-4 text-center">
                    <span className="inline-flex items-center px-3 py-1 rounded-full bg-purple-500/20 border border-purple-500/30 text-purple-300 text-xs font-mono">
                        ✨ Career glimpse unlocked
                    </span>
                </div>
            )}
        </div>
    );
};

export default JourneyProgress;
